import { Task, TaskStates } from "../../../generated/graphql";

export function tasksInStates(tasks: Task[], states: TaskStates[]): boolean {
    return tasks.every(task => states.includes(task.state as TaskStates));
}

export function tasksNotInStates(tasks: Task[], states: TaskStates[]): boolean {
    return tasks.every(task => !states.includes(task.state as TaskStates));
}
